// Nachkommastellen eines Formularfelds (`field_decimals`).
//
// Diese Datei ist die Client-Hälfte einer Regel, die es zweimal gibt. Die
// Quelle ist das Backend: `app/api/helper/checklist/field_decimals.js` in
// `8p2-cld-backend` (`normalizeFieldDecimals`, `setFieldDecimals`). Der Server
// normalisiert jeden Einlasspfad und löscht, was keine Ganzzahl 0..100 ist —
// auch den Designer-Payload (`updateQuestion`).
//
// Warum die Regel hier trotzdem noch einmal steht: ohne sie tippt der Anwender
// `2,5`, sieht den Wert in der Maske stehen, speichert — und der Server
// verwirft ihn still. Die Maske muss deshalb genau das zulassen, was der
// Transport zulässt, nicht mehr und nicht weniger. Der Server bleibt die
// Absicherung, diese Datei ist die Fehlermeldung.
//
// Ändert sich die Regel, ändert sie sich in beiden Repos im selben Zug
// (Vertrag: `contracts/checklist-formfield-decimals.md`).
//
// `0` ist ein gültiger, setzbarer Wert (auf ganze Zahlen runden). Deshalb darf
// weder hier noch beim Aufrufer auf Truthiness geprüft werden.
//
// Obergrenze 100: `Number.prototype.toFixed` wirft außerhalb von 0..100 eine
// RangeError. Technische Grenze, keine fachliche.
export const MAX_FIELD_DECIMALS = 100;

/**
 * @param {*} value Rohwert aus dem Eingabefeld oder aus dem geladenen Datensatz.
 * @returns {number|undefined} Ganzzahl 0..100 oder `undefined` (= nicht gesetzt).
 */
export function normalizeFieldDecimals(value) {
  if (typeof value !== "number" && typeof value !== "string") return undefined;
  if (typeof value === "string" && value.trim().length === 0) return undefined;

  const n = Number(value);
  if (!Number.isInteger(n)) return undefined;
  if (n < 0 || n > MAX_FIELD_DECIMALS) return undefined;

  return n;
}

/**
 * Trägt der Datensatz überhaupt eine Angabe? Bewusst nicht über
 * `normalizeFieldDecimals`: ein (heute nicht erzeugbarer) ungültiger
 * Altwert soll sichtbar und korrigierbar bleiben, statt still ausgeblendet zu
 * werden. `0` zählt als gesetzt.
 *
 * @param {*} value Wert des Attributs `field_decimals`.
 * @returns {boolean}
 */
export function isFieldDecimalsPresent(value) {
  if (value === undefined || value === null) return false;
  return String(value).trim().length > 0;
}
